import React from 'react';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import { IStaffMember } from '../../Staff/staff-hook';
import { AddUser, HidePassword, ShowPassword } from '../../../../../../Assets/Icons';
import useCreateStaffMember from './addStaffMember-hook';
import styles from './addStaff.module.scss';
import AuthInput from '../../../../../../Components/Inputs/AuthInput/authInput';
import { Controller } from 'react-hook-form';
import AutoComplete from '../../../../../../Components/Inputs/AutoComplete/autoComplete';
import { useDirectoriesHook } from '../../../../../../Hooks/hooks';
import Button from '../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';
import TelInput from '../../../../../../Components/Inputs/TelInput/telInput';
import { usePassword } from '../../../../../../Components/Inputs/input-hooks';

export interface ICreateStaffProps {
    onCreate: (data: IStaffMember) => void,
    company_id: number,
    onCloseDialog: () => void
}

const AddStaffMemberDialog: React.FC<ICreateStaffProps> = (props) => {
    const { t } = useLanguagesHooks();
    const { register, control, onAddMember, errors, isValid } = useCreateStaffMember(props);
    const { roles } = useDirectoriesHook();
    const { password, changeType } = usePassword();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={AddUser} alt='add.svg' />
                <p>
                    {t('My_Business.Personal.Create')}
                </p>
            </div>
            <form className={styles.form}>
                <div className={styles.item}>
                    <div className={styles.label}>
                        <p>
                            {t('My_Business.Personal.Select_Role')}
                        </p>
                    </div>
                    <Controller
                        control={control}
                        name='user_role'
                        rules={{
                            required: t('Errors.Required'),
                        }}
                        render={({ field: { onChange, name, value } }) => {
                            return (
                                <AutoComplete
                                    value={value}
                                    name={name}
                                    onChange={onChange}
                                    id='user_role'
                                    data={roles}
                                    error={errors.user_role}
                                    style={styles.autocomplete}
                                />
                            );
                        }}
                    />
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>
                        <p>
                            {t('My_Business.Personal.First_Name')}
                        </p>
                    </div>
                    <AuthInput
                        register={register}
                        registerName='first_name'
                        labelStyle={styles.inputLabel}
                        error={errors.first_name}
                        patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
                    />
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>
                        <p>
                            {t('My_Business.Personal.Last_Name')}
                        </p>
                    </div>
                    <AuthInput
                        register={register}
                        registerName='last_name'
                        labelStyle={styles.inputLabel}
                        error={errors.last_name}
                        patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
                    />
                </div>
                <TelInput
                    name='phone_number'
                    control={control}
                    label={t('Sign_Up.Phone')}
                    error={errors.phone_number}
                    labelStyle={styles.label}
                />
                <div className={styles.item}>
                    <div className={styles.label}>
                        <p>
                        {t('My_Business.Personal.UserName')}
                        </p>
                    </div>
                    <AuthInput
                        register={register}
                        registerName='user_name'
                        labelStyle={styles.inputLabel}
                        error={errors.user_name}
                        patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
                    />
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>
                        <p>
                        {t('My_Business.Personal.Password')}
                        </p>
                    </div>
                    <AuthInput
                        register={register}
                        registerName='password'
                        type={password ? 'password' : 'text'}
                        patternValue={
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#/+_,.^])[A-Za-z\d@$#!%*.,^/+_?&]{8,}$/gm
                        }
                        message={t('Errors.Password')}
                        error={errors.password}
                        inputBoxStyles={styles.passwordInput}
                        children={
                            <img
                                className={styles.inputIcon}
                                src={password ? HidePassword : ShowPassword}
                                alt="eyeIcon"
                                onClick={changeType}
                            />
                        }
                    />
                </div>
            </form>
            <div className={styles.buttonsRow}>
                <Button
                    buttonType={ButtonTypes.Secondary}
                    title={t('Buttons.Close')}
                    type='button'
                    onClick={props.onCloseDialog}
                    buttonStyle={styles.closeButton}
                />
                <Button
                    buttonType={isValid ? ButtonTypes.Primery : ButtonTypes.Disabled}
                    title={t('Buttons.Create')}
                    type='button'
                    onClick={onAddMember}
                    // isLoading={createLoading}
                    buttonStyle={styles.button}
                    disable={!isValid}
                />
            </div>
        </div>
    )
}

export default AddStaffMemberDialog
